module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_2_3_2-e21c379e8f138b65c11966695ee7ce7c.webp";